/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{horizontalWkidHeightUnitFeet as e,verticalWkidHeightUnitFeet as t,ellipsoidalWkid as r}from"./wkid.js";function n(t){return e.includes(t)?"feet":"meters"}function i(e,r){return"number"==typeof e?t.includes(e)?"feet":"meters":n(r)}function u(e,t){return r.includes(e)||4326===t?"ellipsoidal":"gravity-related-height"}export{u as getHeightModel,n as getHorizontalUnit,i as getVerticalUnit};
